// Drag hint bar — shown at top during drag-to-link operations

import { Link } from 'lucide-react'

interface DragHintBarProps {
  visible: boolean
  sourceTitle?: string
}

export function DragHintBar({ visible, sourceTitle }: DragHintBarProps) {
  if (!visible) return null

  return (
    <div className="bg-core/[0.08] border-b-2 border-core px-5 py-2 text-center text-[13px] text-core font-medium backdrop-blur-sm flex-shrink-0 flex items-center justify-center gap-2">
      <Link size={14} />
      Drag to a node in the other space to create a link
      {sourceTitle && <span className="text-core/60">— dragging &ldquo;{sourceTitle}&rdquo;</span>}
    </div>
  )
}
